import { changeOrderUrl, viewEditOrderUrl } from "@saleor/changeOrder/urls";
import { Pagination, Sort } from "@saleor/types";
import { stringifyQs } from "@saleor/utils/urls";
import urlJoin from "url-join";

export enum ExporOrderListSortField {
  piNo = "piNo",
  eoNo = "eoNo",
  poNo = "poNo",
  soldTo = "soldTo",
  createDate = "createDate"
}

export enum ChangeOrderSortField {
  material_code = "material_code"
}

export interface OrderListUrlAdditional {
  filtered: boolean;
}

export type ExporOrderListUrlSort = Sort<ExporOrderListSortField>;
export type ExporOrderListUrlQueryParams = Pagination &
  ExporOrderListUrlSort &
  OrderListUrlAdditional;

export type ChangeOrderUrlSort = Sort<ChangeOrderSortField>;
export type ChangeOrderQueryParams = Pagination & ChangeOrderUrlSort;

export const exporOrderListUrl = (params?: ExporOrderListUrlQueryParams) =>
  changeOrderUrl + "?" + stringifyQs(params);

export const changeOrderPath = (id: string) => urlJoin(viewEditOrderUrl, id);
export const viewEditOrderParamUrl = (
  id: string,
  params?: ChangeOrderQueryParams
) => changeOrderPath(encodeURIComponent(id)) + "?" + stringifyQs(params);

export interface OrderProcessingParams {
  callback?: string;
}

export const orderProcessing = `${changeOrderUrl}/order-processing`;
export const orderProcessingParamUrl = (params?: OrderProcessingParams) =>
  orderProcessing + "?" + stringifyQs(params);
